<svg:polyline id="tile-{{ coord()!.x }}-{{ coord()!.y }}-{{ coord()!.z }}"
              [attr.points]="get3DIsoSquarePoints()"
              [ngClass]="pieceClasses()"/>
@if (mustDisplayHeight()) {
    <svg:text id="height-{{ coord()!.x }}-{{ coord()!.y }}-{{ coord()!.z }}"
              x="50"
              y="66"
              class="text-big text-center"
              [innerHTML]="coord()!.z">
    </svg:text>
}
@if (isBottomHalf() === false || mustForceStrokeDisplay()) {
    <svg:polyline id="line-0-to-1"
                  [ngClass]="pieceClasses()"
                  class="base manual-stroke"
                  [attr.points]="getUpperHorizontalLine()"/>
}
@if (isTopHalf() === false || mustForceStrokeDisplay()) {
    <svg:g>
        <svg:polyline [attr.points]="getMiddleHorizontalLine()"
                      id="line-2-to-3"
                      [ngClass]="pieceClasses()"
                      class="base manual-stroke"/>
        <svg:polyline [attr.points]="getLowerHorizontalLine()"
                      id="line-5-to-6"
                      [ngClass]="pieceClasses()"
                      class="base manual-stroke"/>
    </svg:g>
}
@if (isRightHalf() === false || mustForceStrokeDisplay()) {
    <svg:polyline id="line-0-to-2"
                  [ngClass]="pieceClasses()"
                  class="base manual-stroke"
                  [attr.points]="getLeftDiagonalLine()"/>
}
@if (isLeftHalf() === false || mustForceStrokeDisplay()) {
    <svg:g>
        <svg:polyline [attr.points]="getMiddleDiagonalLine()"
                      id="line-1-to-3"
                      class="base manual-stroke"
                      [ngClass]="pieceClasses()"/>
        <svg:polyline [attr.points]="getRighterDiagonalLine()"
                      id="line-4-to-6"
                      [ngClass]="pieceClasses()"
                      class="base manual-stroke"/>
    </svg:g>
}
@if (isBottomHalf() || isLeftHalf() || mustForceStrokeDisplay()) {
    <svg:polyline id="line-2-to-5"
                  [ngClass]="pieceClasses()"
                  class="base manual-stroke"
                  [attr.points]="getLeftVerticalLine()"/>
}
@if (isBottomHalf() || isRightHalf() || mustForceStrokeDisplay()) {
    <svg:polyline id="line-3-to-6"
                  [ngClass]="pieceClasses()"
                  class="base manual-stroke"
                  [attr.points]="getMiddleVerticalLine()"/>
}
@if (isTopHalf() || isRightHalf() || mustForceStrokeDisplay()) {
    <svg:polyline id="line-1-to-4"
                  [ngClass]="pieceClasses()"
                  class="base manual-stroke"
                  [attr.points]="getRighterVerticalLine()"/>
}
